import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { UserAttributes } from 'shared/types'
import { getCurrentUserInfo } from 'shared/store/auth/selectors'
import { getCurrentUserInfo as getUserInfo } from 'shared/store/auth/actions'

type CurrentUser = {
  attributes: {
    avatarUrl: string
    name: string
  }
  username: string
}

export const useUserInfo = (): CurrentUser => {
  const { attributes, ...userInfo } = useSelector(getCurrentUserInfo)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getUserInfo())
  }, [dispatch])

  return {
    ...userInfo,
    attributes: attributes
      ? {
          ...attributes,
          avatarUrl: attributes[UserAttributes.avatarUrl],
        }
      : {
          avatarUrl: '',
          name: '',
        },
  }
}
